import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const deleteCampaign = ({ churchId, campaignId }) => {
  return axios.delete(`/churches/${churchId}/campaigns/${campaignId}`);
};

export const useDeleteCampaign = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeDeleteModal = useCentralStore.getState().closeDeleteModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("campaigns-paginated");

      setNotification({
        type: "success",
        message: "Campaign deleted successfully!"
      });
      closeDeleteModal();
    },
    ...config,
    mutationFn: deleteCampaign
  });
};
